import { Controller } from "@hotwired/stimulus"

// Remembers whether a <details> is open across Turbo Frame re-renders, in
// sessionStorage under `key`. The server renders it open when it holds a
// selection; this keeps it open when the somm opened it by hand.
export default class extends Controller {
  static values = { key: String }

  connect() {
    try {
      const stored = sessionStorage.getItem(this.storageKey)
      if (stored !== null) this.element.open = stored === "1"
    } catch (e) { /* best effort */ }
    this.onToggle = () => {
      try { sessionStorage.setItem(this.storageKey, this.element.open ? "1" : "0") } catch (e) { /* best effort */ }
    }
    this.element.addEventListener("toggle", this.onToggle)
  }

  disconnect() {
    this.element.removeEventListener("toggle", this.onToggle)
  }

  get storageKey() {
    return `winote_details:${this.keyValue}`
  }
}
